import React, { useEffect, useState } from "react";
import CoreInputField from "../../../app/core/components/CoreInputField/CoreInputField";
import CoreButton from "../../../app/core/components/CoreButton/CoreButton";
import { t } from "i18next";
import { FormControlLabel, Radio, RadioGroup } from "@mui/material";
import { toast } from "react-toastify";
import { useSelector } from "react-redux";
import { useGetCommercialistaIdQuery } from "../../api/admin/gestisciCommercialistiApi";
import { useDoAutoMessageMutation } from "../../api/admin/adminAccount";
import CoreMaxCharacter from "../../../app/core/components/CoreMaxCharacter/CoreMaxCharacter";

const AutoMessage = ({ onClose }) => {
  const [formData, setFormData] = useState({
    active: true,
    message: "",
  });
  const adminId = useSelector((state) => state.app.adminId);

  const {
    data: adminData,
    isLoading,
    refetch,
  } = useGetCommercialistaIdQuery(adminId, {
    skip: !adminId,
  });

  const [doAutoMessage] = useDoAutoMessageMutation();

  const handleChangeRadio = (event) => {
    setFormData({
      ...formData,
      active: event.target.value === "true",
    });
  };

  useEffect(() => {
    if (adminData) {
      setFormData((prevData) => ({
        ...prevData,
        active: adminData.Data.chatAutoReply,
        message: adminData.Data.chatAutoReplyMessage,
      }));
    }
  }, [adminData]);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prevData) => ({
      ...prevData,
      [name]: value,
    }));
  };

  const handleSave = () => {
    try {
      const autoMsg = {
        chatAutoReply: formData.active,
        chatAutoReplyMessage: formData.message,
      };
      doAutoMessage(autoMsg)
        .unwrap()
        .then((res) => {
          if (res.Result !== 1) {
            toast.error(t("AutoMessageNotSalved"));
            return;
          }
          toast.success(t("AutoMessageSalved"));
          refetch();
          onClose();
        });
    } catch (err) {
      toast.error(t("ReqErr"));
      console.log(err);
    }
  };

  const handleDelete = () => {
    try {
      const autoMsg = {
        chatAutoReply: false,
        chatAutoReplyMessage: null,
      };
      doAutoMessage(autoMsg)
        .unwrap()
        .then((res) => {
          if (res.Result !== 1) {
            toast.error(t("AutoMessageNotDeleted"));
            return;
          }
          toast.success(t("AutoMessageDeleted"));
          refetch();
          onClose();
        });
    } catch (err) {
      toast.error(t("ReqErr"));
      console.log(err);
    }
  };

  return (
    <div className="flex flex-col justify-center items-center">
      <h2>{t("AutoMessage")}</h2>
      <div className=" w-2/3 py-8">
        <div className="flex justify-between items-center pb-2">
          <p className="m-0 font-bold">
            {t("Active") + " " + t("AutoMessage")}
          </p>

          <RadioGroup
            row
            value={formData.active}
            className="flex"
            onChange={handleChangeRadio}
          >
            <FormControlLabel
              value={true}
              control={<Radio size="small" />}
              label={t("Yes")}
            />
            <FormControlLabel
              value={false}
              control={<Radio size="small" />}
              label={t("No")}
            />
          </RadioGroup>
        </div>

        <CoreInputField
          multiline
          minRows={10}
          maxRows={20}
          variant="outlined"
          className="w-full"
          label={t("Content")}
          name="message"
          onChange={handleChange}
          value={formData.message}
        />
        <CoreMaxCharacter maxCharacter={Infinity} text={formData.message} />
      </div>

      <div className="flex w-6/12 justify-around mt-4 py-8">
        <CoreButton
          className="bg-red-700 btn-round border-red-700"
          variant="contained"
          testo={t("Delete")}
          onClick={handleDelete}
          disabled={!formData.message}
        />
        <CoreButton
          testo={t("Save")}
          className={`bg-primary btn-round border-primary  `}
          onClick={handleSave}
          disabled={isLoading}
        />
      </div>
    </div>
  );
};

export default AutoMessage;
